import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/field/$fieldId/$")({
    component: RouteComponent,
    beforeLoad: async ({ params }) => {
        if (localStorage.getItem("oldNTime") === "false") {
            throw redirect({
                to: `/dashboard/fields/$fieldId/${params._splat}` as "/dashboard/fields/$fieldId",
                params: { fieldId: params.fieldId },
            });
        } else {
            throw redirect({
                to: `/ntimev1/$`,
                params: {
                    _splat: `/dashboard/field/${params.fieldId}/${params._splat}`,
                },
            });
        }
    },
});

function RouteComponent() {
    return null;
}
